export default "/images/user_balance.png?0aca49d4eafd6f8eed9fa7ad8d1cee79";